/* ==========================================================================
   TUCANO · Guida bagagli (editorial)
   ─ Tabs categoria → filtra prodotti per misura (fits underseat/cabin/stiva)
   ─ "Vedi i modelli" delle card categoria → scroll smooth + attiva tab
   ========================================================================== */
(() => {
  'use strict';

  const root = document.querySelector('[data-tcn-guide]');
  if (!root) return;

  // ---------- Tabs + product grid ----------
  const productsSection = root.querySelector('[data-tcn-guide-products]');
  if (productsSection) {
    const tabs = root.querySelectorAll('[data-tcn-guide-tab]');
    const grid = productsSection.querySelector('.tcn-guide__grid');
    const items = productsSection.querySelectorAll('[data-tcn-guide-item]');
    const emptyEl = productsSection.querySelector('[data-tcn-guide-empty]');

    function parseDims(str) {
      if (!str) return null;
      const cleaned = String(str)
        .toLowerCase()
        .replace(/cm/g, '')
        .replace(/,/g, '.')
        .replace(/×/g, 'x')
        .replace(/\s+/g, '');
      const parts = cleaned.split('x').map(Number).filter((n) => n > 0);
      if (parts.length !== 3) return null;
      return parts;
    }

    function sortedDesc(arr) { return [...arr].sort((a, b) => b - a); }

    function fits(p, m) {
      if (!p || !m) return false;
      const ps = sortedDesc(p);
      const ms = sortedDesc(m);
      return ps[0] <= ms[0] && ps[1] <= ms[1] && ps[2] <= ms[2];
    }

    function setCategory(cat) {
      const limit = parseDims(grid.dataset[cat]);
      let visible = 0;
      items.forEach((item) => {
        const dims = parseDims(item.dataset.dims);
        const ok = fits(dims, limit);
        item.hidden = !ok;
        if (ok) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;

      tabs.forEach((t) => {
        const active = t.dataset.tcnGuideTab === cat;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setCategory(tab.dataset.tcnGuideTab));
    });

    // Init: prima tab attiva (under)
    const initialTab = root.querySelector('[data-tcn-guide-tab].is-active');
    if (initialTab) setCategory(initialTab.dataset.tcnGuideTab);
  }

  // ---------- Card categoria "Vedi i modelli X" → smooth scroll + attiva tab ----------
  const jumpLinks = root.querySelectorAll('[data-tcn-guide-jump]');
  jumpLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const cat = link.dataset.tcnGuideJump;
      const target = root.querySelector('[data-tcn-guide-products]');
      if (!target) return;
      e.preventDefault();
      // Attiva la tab corrispondente prima dello scroll
      const tab = root.querySelector(`[data-tcn-guide-tab="${cat}"]`);
      if (tab) tab.click();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
